
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsde988df3bc90b496762ec4b94aab83a7en from './en.yaml'
            i18n.addResourceBundle('en', 'de988df3bc90b496762ec4b94aab83a7', flattenObject(nsde988df3bc90b496762ec4b94aab83a7en), true, true);
        
        export default 'de988df3bc90b496762ec4b94aab83a7';
    